import {
  Bath,
  CableCar,
  Dog,
  Fish,
  Flame,
  Gamepad2,
  PartyPopper,
  Plug,
  Trees,
  Tv,
  Users,
  Wifi,
  WashingMachine,
} from "lucide-react";
import { Reveal, MaskReveal } from "./Reveal";
import { PHOTO_SIZES, PHOTOS } from "./images";

const AMENITIES = [
  { icon: Bath, label: "Full RV Hookups" },
  { icon: Plug, label: "30 & 50 Amp Service" },
  { icon: Wifi, label: "Wi-Fi" },
  { icon: Tv, label: "Cable TV" },
  { icon: WashingMachine, label: "Onsite Laundry" },
  { icon: Dog, label: "Off-Leash Pet Area" },
  { icon: Users, label: "Clubhouse" },
  { icon: Gamepad2, label: "Shuffleboard, Poker Table and Games" },
  { icon: Trees, label: "Covered Picnic Area" },
  { icon: Flame, label: "Barbecue Pits" },
  { icon: PartyPopper, label: "Event and Meeting Space" },
  { icon: Fish, label: "Nearby Boating and Fishing" },
];

export function AmenitiesSection() {
  const clubhouse = PHOTOS.clubhouse;
  const covered = PHOTOS.coveredParking;

  return (
    <section
      className="bg-forest-deep py-24 text-cream sm:py-28 lg:py-32"
      aria-labelledby="amenities-title"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.15fr] lg:items-end lg:gap-20">
          <Reveal>
            <p className="eyebrow text-sand">Amenities</p>
            <h2
              id="amenities-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Everything You Need to Settle In
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-cream/80">
              The clubhouse stays busy, the laundry is steps away, and the pet park gives everyone
              room to stretch out after a long drive.
            </p>
          </Reveal>

          <MaskReveal className="media-zoom rounded-sm">
            <img
              src={clubhouse.src}
              srcSet={clubhouse.srcSet}
              sizes={PHOTO_SIZES.half}
              alt={clubhouse.alt}
              width={clubhouse.width}
              height={clubhouse.height}
              loading="lazy"
              decoding="async"
              className="aspect-[16/9] w-full rounded-sm object-cover"
            />
          </MaskReveal>
        </div>

        <div className="mt-16 grid gap-x-10 gap-y-0 lg:grid-cols-[1.4fr_1fr] lg:gap-20">
          <ul className="grid gap-x-10 sm:grid-cols-2">
            {AMENITIES.map((item, i) => (
              <Reveal as="li" key={item.label} delay={(i % 4) * 0.05}>
                <div className="flex items-center gap-4 border-b border-cream/15 py-5">
                  <item.icon className="size-5 shrink-0 text-sand" aria-hidden="true" />
                  <span className="text-sm font-medium leading-snug text-cream/95">
                    {item.label}
                  </span>
                </div>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={0.1} className="mt-12 lg:mt-0">
            <div className="media-zoom rounded-sm">
              <img
                src={covered.src}
                srcSet={covered.srcSet}
                sizes="(min-width: 1024px) 35vw, 100vw"
                alt={covered.alt}
                width={covered.width}
                height={covered.height}
                loading="lazy"
                decoding="async"
                className="aspect-[3/4] w-full rounded-sm object-cover"
              />
            </div>
            <p className="mt-5 flex items-start gap-3 text-sm leading-relaxed text-cream/70">
              <CableCar className="mt-0.5 size-4 shrink-0 text-sand" aria-hidden="true" />
              Covered spaces keep rigs and boats out of the South Texas sun between trips to the
              lake.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
